import {Field, FieldArray, Form, Formik} from 'formik'
import React, {useEffect, useState} from 'react'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {useNavigate, useParams} from 'react-router-dom'
import {RootState} from '../../../../setup'
import {Breadcrumbs, Route} from '../../../components/Breadcrumbs'
import {formatDateTime} from '../../../helper'
import {
  MaterialRequisitionInitValues,
  MaterialRequisitionModel,
} from '../models/MaterialRequisitionModel'
import * as MaterialRequestAction from '../redux/MaterialRequisitionAction'
import {MaterialRequisitionApproveConfirmModal} from './MaterialRequisitionApproveConfirmModal'
import {MaterialRequisitionRejectConfirmModal} from './MaterialRequisitionRejectConfirmModal'
import {Loader} from '../../../components/Loader'
import {NoItemFound} from '../../../components/NoItemFound'

type Props = {
  className: string
}

export const MaterialRequisitionApprove: React.FC<Props> = ({className}) => {
  const materialRequisition: any = useSelector<RootState>(
    ({materialRequisition}) => materialRequisition.materialRequisition,
    shallowEqual
  )

  const loading: any = useSelector<RootState>(
    ({materialRequisition}) => materialRequisition.loading,
    shallowEqual
  )

  const [showApproveDialog, setShowApproveDialog] = useState(false)
  const [materialRequisitionToApprove, setMaterialRequisitionToApprove] =
    useState<MaterialRequisitionModel>(MaterialRequisitionInitValues)
  const [showRejectDialog, setShowRejectDialog] = useState(false)
  const [materialRequisitionToReject, setMaterialRequisitionToReject] =
    useState<MaterialRequisitionModel>(MaterialRequisitionInitValues)

  const materialRequisitionUpdatedValues = {
    ...materialRequisition,
    requestedDate: formatDateTime(materialRequisition?.requestedDate),
    approvedAt: formatDateTime(materialRequisition?.approvedAt),
  }

  const dispatch: any = useDispatch()
  let {id} = useParams<{id: any}>()

  useEffect(() => {
    dispatch(MaterialRequestAction.fetchOne(id))
  }, [dispatch, id])

  let routes: Route[] = [
    {name: 'Dashboard', url: '/dashboard'},
    {name: 'Material Requisitions List', url: '/material-requisition'},
    {name: 'Material Requisition Approval Form', url: ''},
  ]

  return (
    <>
      <MaterialRequisitionRejectConfirmModal
        show={showRejectDialog}
        handleClose={() => {
          setShowRejectDialog(false)
        }}
        materialRequisition={materialRequisitionToReject}
      />
      <MaterialRequisitionApproveConfirmModal
        show={showApproveDialog}
        handleClose={() => {
          setShowApproveDialog(false)
        }}
        materialRequisition={materialRequisitionToApprove}
      />
      <div className={`card card-custom ${className}`}>
        <Breadcrumbs routes={routes} />
        <div className='card-header border-0 pt-5'>
          <h1 className='card-title'>
            <span className='card-label fw-bolder fs-3 mb-1'>
              Material Requisition Approval Form
            </span>
          </h1>
        </div>

        <div className='card-body py-10'>
          {!loading ? (
            materialRequisition && materialRequisition?._id !== '' ? (
              <Formik
                initialValues={materialRequisitionUpdatedValues || MaterialRequisitionInitValues}
                enableReinitialize
                onSubmit={(values: any) => {
                  setShowApproveDialog(true)
                  setMaterialRequisitionToApprove(materialRequisitionUpdatedValues)
                }}
              >
                {({values}) => (
                  <Form>
                    <div className='row row-cols-lg-2 row-cols-md-2 row-cols-1 g-5'>
                      <div className='form-group col'>
                        <label htmlFor='number' className='fw-bold'>
                          Material Requisition No.
                        </label>
                        <Field
                          name='number'
                          className='form-control form-control-lg '
                          disabled={true}
                        />
                      </div>
                      <div className='form-group col'>
                        <label htmlFor='requestedDate' className='fw-bold'>
                          Created Date
                        </label>
                        <Field
                          name='requestedDate'
                          disabled={true}
                          className='form-control form-control-lg '
                        />
                      </div>
                      <div className='form-group col'>
                        <label htmlFor='requestedBy' className='fw-bold '>
                          Request by Employee Name
                        </label>
                        <Field
                          name='requestedBy.fullName'
                          className='form-control form-control-lg '
                          disabled={true}
                        />
                      </div>
                      <div className='form-group col'>
                        <label htmlFor='department' className='fw-bold '>
                          Request By Department
                        </label>

                        <Field
                          className='form-control form-control-lg '
                          name='department.name'
                          disabled={true}
                        />
                      </div>
                      <div className='form-group col'>
                        <label htmlFor='location' className='fw-bold '>
                          Location
                        </label>
                        <Field
                          className='form-control form-control-lg '
                          name='location.name'
                          disabled={true}
                        />
                      </div>
                    </div>

                    <FieldArray
                      name='items'
                      render={(arrayHelpers) => (
                        <div className='mt-15'>
                          <table className='table tbl-md-responsivness'>
                            <thead>
                              <tr>
                                <th>
                                  <label className='form-label '>Product</label>
                                </th>
                                <th>
                                  <label className='form-label '>UOM</label>
                                </th>
                                <th>
                                  <label className='form-label '>Quantity</label>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.items?.length > 0 &&
                                values?.items?.map((materialItem: any, index: any) => (
                                  <React.Fragment key={index}>
                                    <tr>
                                      <td data-label='Name'>
                                        <div className='d-flex flex-column w-100'>
                                          <Field
                                            name={`items.${index}.name`}
                                            disabled={true}
                                            className='form-control form-control-md'
                                          />
                                        </div>
                                      </td>

                                      <td data-label='UOM'>
                                        <div className='d-flex flex-column w-100'>
                                          <Field
                                            name={`items.${index}.UOM`}
                                            disabled={true}
                                            className='form-control form-control-md'
                                          />
                                        </div>
                                      </td>

                                      <td data-label='Quantity'>
                                        <div className='d-flex flex-column w-100'>
                                          <Field
                                            name={`items.${index}.quantity`}
                                            disabled={true}
                                            className='form-control form-control-md'
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    />

                    <div className='d-flex justify-content-end mt-10'>
                      <button
                        type='button'
                        className='btn btn-lg btn-light-primary fw-bolder py-4 pe-8 me-3'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        title='Reject'
                        onClick={() => {
                          setShowRejectDialog(true)
                          setMaterialRequisitionToReject(materialRequisitionUpdatedValues)
                        }}
                      >
                        <span className='indicator-label'>Reject</span>
                      </button>

                      <button
                        type='submit'
                        className='btn btn-lg  btn-primary me-3'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        title='Approve'
                        id='liveToastBtn'
                      >
                        <span className='indicator-label'>Approve</span>
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            ) : (
              <NoItemFound />
            )
          ) : (
            <Loader />
          )}
        </div>
      </div>
    </>
  )
}
